export const Footer = () => {

    
    

    return (
    <>
    <footer className="footer-border">
        <div className="container-lg">
        <span>© <span id="year">{(new Date().getFullYear())}</span> Bilflo</span>
        </div>
    </footer>
    </>
    );

    

    
}